// Mock data for Microworld Solution website

export const companyInfo = {
  name: "Microworld Solution",
  tagline: "A Canadian IT Leader",
  description: "Microworld Solution specializes in IT services, data management, cloud services, CRM support, and server maintenance.",
  phone: "905 909 7555",
  email: "info@microworldsolutions.ca",
  locations: [
    {
      id: 1,
      address: "52 Angelgate Road",
      city: "Brampton",
      province: "Ontario",
      postalCode: "L6Y 0X9",
      country: "Canada"
    },
    {
      id: 2,
      address: "207-1425 Marine Drive",
      city: "West Vancouver",
      province: "BC",
      postalCode: "V7T 1B9",
      country: "Canada"
    }
  ]
};

export const services = [
  {
    id: 1,
    title: "IT Services",
    description: "Comprehensive IT support and management solutions to keep your business running smoothly. We handle all your technology needs so you can focus on growth.",
    icon: "Monitor"
  },
  {
    id: 2,
    title: "Data Management",
    description: "Secure, efficient data storage and management solutions. We help you organize, protect, and leverage your business data for better decision-making.",
    icon: "Database"
  },
  {
    id: 3,
    title: "Cloud Services",
    description: "Upgrade your business with our fully managed and secure cloud-based services. Scale efficiently with flexible cloud infrastructure and reduce costs.",
    icon: "Cloud"
  },
  {
    id: 4,
    title: "CRM Support",
    description: "Expert CRM implementation, customization, and support services. Optimize your customer relationships and streamline your sales processes.",
    icon: "Users"
  },
  {
    id: 5,
    title: "Server Maintenance",
    description: "Proactive server monitoring, maintenance, and optimization to ensure maximum uptime and performance for your critical business systems.",
    icon: "Server"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Client-Focused Approach",
    description: "We prioritize client satisfaction and success above all. We take the time to learn your business needs to facilitate a long-term partnership."
  },
  {
    id: 2,
    title: "Certified Professionals",
    description: "We employ certified professionals with decades of IT experience who will provide tailored, business-centric solutions to meet any challenge."
  },
  {
    id: 3,
    title: "Premium Service",
    description: "We offer a premium, white-glove service that guarantees precision and attention to detail when handling all aspects of your business's IT needs."
  },
  {
    id: 4,
    title: "Future-Ready Solutions",
    description: "We stay ahead of technology trends and will provide your business with customized IT strategies to support growth and operational efficiency."
  }
];

export const stats = [
  {
    id: 1,
    value: "10+",
    label: "Years of Experience"
  },
  {
    id: 2,
    value: "150+",
    label: "Satisfied Clients"
  },
  {
    id: 3,
    value: "99.9%",
    label: "Uptime Guarantee"
  },
  {
    id: 4,
    value: "24/7",
    label: "Support Available"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Microworld Solution has transformed our IT infrastructure completely. Their team is responsive, knowledgeable, and always goes the extra mile to ensure our systems run smoothly.",
    author: "Sarah Mitchell",
    company: "TechVentures Inc.",
    role: "CEO"
  },
  {
    id: 2,
    quote: "By outsourcing our IT services to Microworld Solution, we've reduced costs significantly while gaining access to cutting-edge security solutions. Highly recommended!",
    author: "Michael Chen",
    company: "Pacific Trade Group",
    role: "Operations Director"
  },
  {
    id: 3,
    quote: "The cloud migration project was handled flawlessly with zero downtime. Their expertise and professionalism exceeded our expectations at every step.",
    author: "Jennifer Adams",
    company: "Maple Financial Services",
    role: "CTO"
  }
];

export const navLinks = [
  { id: 1, label: "Home", href: "#home" },
  { id: 2, label: "Services", href: "#services" },
  { id: 3, label: "About", href: "#about" },
  { id: 4, label: "Testimonials", href: "#testimonials" },
  { id: 5, label: "Contact", href: "#contact" }
];
